import React from 'react';
import { Link } from 'react-router-dom';

const TeamCarousel = () => {
    return (
        <section>
            <div className="stg-row infocolors-section-title">
                <div className="stg-col-8 stg-offset-2 stg-tp-col-10 stg-tp-offset-1">
                    <div className="align-center">
                        <h2 data-appear="fade-up" data-unload="fade-up">Meet Our Partners</h2>
                        <p className="infocolors-large-text" data-split-appear="fade-up" data-split-unload="fade-up" data-delay="100">We have a network of A-list professionals spread across the country.</p>
                    </div>
                </div>
            </div>
            <div className="swiper infocolors-carousel" data-appear="fade-up" data-delay="200" data-tp-centered="0" data-unload="fade-up">
                <div className="swiper-wrapper">
                    <div className="infocolors-block infocolors-carousel-card swiper-slide">
                        <div className="infocolors-carousel-card-image">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/team/dj.jpg" alt="Shot by David John" width="600" height="900" />
                        </div>
                        <div className="infocolors-carousel-card-footer">
                            <div className="infocolors-carousel-card-title">
                                <span className="infocolors-meta">Technical Partner</span>
                                <h6>Shot by David John</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <Link to="https://www.instagram.com/bydavidjohn/"></Link>
                    </div>
                    <div className="infocolors-block infocolors-carousel-card swiper-slide">
                        <div className="infocolors-carousel-card-image">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/team/mj.jpg" alt="Mathew Jibunor" width="600" height="900" />
                        </div>
                        <div className="infocolors-carousel-card-footer">
                            <div className="infocolors-carousel-card-title">
                                <span className="infocolors-meta">Technical Partner</span>
                                <h6>Mathew Jibunor</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <Link to="https://www.instagram.com/_jibunor/"></Link>
                    </div>
                    <div className="infocolors-block infocolors-carousel-card swiper-slide">
                        <div className="infocolors-carousel-card-image">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/team/dj.jpg" alt="Shot by David John" width="600" height="900" />
                        </div>
                        <div className="infocolors-carousel-card-footer">
                            <div className="infocolors-carousel-card-title">
                                <span className="infocolors-meta">Technical Partner</span>
                                <h6>Shot by David John</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <Link to="https://www.instagram.com/bydavidjohn/"></Link>
                    </div>
                    <div className="infocolors-block infocolors-carousel-card swiper-slide">
                        <div className="infocolors-carousel-card-image">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/team/mj.jpg" alt="Mathew Jibunor" width="600" height="900" />
                        </div>
                        <div className="infocolors-carousel-card-footer">
                            <div className="infocolors-carousel-card-title">
                                <span className="infocolors-meta">Technical Partner</span>
                                <h6>Mathew Jibunor</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <Link to="https://www.instagram.com/_jibunor/"></Link>
                    </div>
                    {/* <div className="infocolors-block infocolors-carousel-card swiper-slide">
                        <div className="infocolors-carousel-card-image">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/team/team03-thmb.jpg" alt="Sonya Altena" width="600" height="900" />
                        </div>
                        <div className="infocolors-carousel-card-footer">
                            <div className="infocolors-carousel-card-title">
                                <span className="infocolors-meta">Client Manager</span>
                                <h6>Teggy Concepts</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <Link to="/team"></Link>
                    </div>
                    <div className="infocolors-block infocolors-carousel-card swiper-slide">
                        <div className="infocolors-carousel-card-image">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/team/team04-thmb.jpg" alt="Nikolas Rome" width="600" height="900" />
                        </div>
                        <div className="infocolors-carousel-card-footer">
                            <div className="infocolors-carousel-card-title">
                                <span className="infocolors-meta">Developer</span>
                                <h6>Nikolas Rome</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <Link to="/team"></Link>
                    </div>
                    <div className="infocolors-block infocolors-carousel-card swiper-slide">
                        <div className="infocolors-carousel-card-image">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/team/team05-thmb.jpg" alt="Candy Tittensor" width="600" height="900" />
                        </div>
                        <div className="infocolors-carousel-card-footer">
                            <div className="infocolors-carousel-card-title">
                                <span className="infocolors-meta">Design Artist</span>
                                <h6>Teggy Concepts</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <Link to="/team"></Link>
                    </div> */}
                </div>
                <div className="swiper-pagination infocolors-dots"></div>
            </div>
        </section>
    );
};

export default TeamCarousel;
